import { apiClient } from "./client";
import { parseStorefrontConfig, StorefrontConfig } from "../config/storefront.schema";

export const fetchStorefrontConfig = async (
  identifier: string
): Promise<StorefrontConfig> => {
  // Identifier can be a slug or a custom domain hostname.
  const { data } = await apiClient.get(`/storefronts/${encodeURIComponent(identifier)}`);
  return parseStorefrontConfig(data);
};
